import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { QuestionCircleOutlined } from '@ant-design/icons';
import React from 'react';
export const helpMenuItem = {
    icon: React.createElement(QuestionCircleOutlined, null),
    id: 'help-menu-item',
    key: 'Support',
    label: React.createElement(React.Fragment, null,
        React.createElement("a", { href: 'https://sonarsoftware.zendesk.com/hc/en-us/', target: '_blank' }),
        React.createElement("span", null, COPY_SPECIFIC.SUPPORT))
};
